// Helper function to get start/end of day in ISO format
function toStartOfDay(date) {
    const d = new Date(date);
    d.setUTCHours(0, 0, 0, 0);
    return d.toISOString();
}

function toEndOfDay(date) {
    const d = new Date(date);
    d.setUTCHours(23, 59, 59, 999);
    return d.toISOString();
}

angular.module("ainapp")
    .controller("trailBalanceController", ["$scope", "app.config", "$http", "$state", "AuthenticationService", "MainService", "$window",
        function ($scope, config, $http, $state, AuthenticationService, MainService, $window) {


            $scope.PageName = "Trail Balance";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.AccLoad = false;
                $scope.TrailBalanace = [];
                $scope.SelectedCostCenters = [];

                $scope.data = [];

                // $scope.Levels = [
                //     {
                //         Id: 0,
                //         Name: "level 1"
                //     },
                //     {
                //         Id: 1,
                //         Name: "level 2"
                //     },
                //     {
                //         Id: 2,
                //         Name: "level 3"
                //     },
                //     {
                //         Id: 3,
                //         Name: "level 4"
                //     },
                //     {
                //         Id: 4,
                //         Name: "level 5"
                //     },
                //     {
                //         Id: 5,
                //         Name: "level 6"
                //     },
                //     {
                //         Id: 6,
                //         Name: "All"
                //     }]

                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.TrailObj = {
                    Level: 6,
                    FromDate: toStartOfDay($scope.d2),
                    ToDate: toEndOfDay(new Date())
                }

                $scope.finyear = {};
                MainService.getCurrentFinancialYear().then(function (response) {
                    $scope.finyear = response.data;
                    $scope.TrailObj.FromDate = toStartOfDay(new Date($scope.finyear.StartDate));
                    $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                });

                $scope.CostCenters = [];
                MainService.CostCentersInTreeList().then(function (response) {
                    $scope.CostCenters = response.data;
                    $scope.SelectedCosts = response.data[0];
                });

            }
            $scope.Init();

            $scope.openCostCenterFilterModal = function () {
                console.log("$scope.openCostCenterFilterModal", $scope.TrailObj);
                AppReactLib.costCenterSelect.RenderCostCenterSelectModal({
                    data: $scope.CostCenters,
                    title: "Select Cost Centers",
                    initialCostCenterIds: $scope.SelectedCostCenters,
                    initialDateRange: {
                        start: $scope.TrailObj.FromDate,
                        end: $scope.TrailObj.ToDate
                    },
                    initialLevelId: $scope.TrailObj.Level,
                    onApply: function (values) {
                        values = values || {};
                        console.log('Applied cost centers:', values);
                        dateRange = values.dateRange || {};

                        $scope.SelectedCostCenters = values.costCenterIds;
                        $scope.TrailObj.FromDate = dateRange.start;
                        $scope.TrailObj.ToDate = dateRange.end;
                        $scope.TrailObj.Level = values.levelId;
                    },
                    onClose: function () {
                        console.log('Modal closed');
                    }
                });
            }

            $scope.KendoSource = new kendo.data.DataSource({
                page: 1,
                pageSize: 100,
                transport: {
                    read: function (o) {

                        o.data.Level = $scope.TrailObj.Level;
                        o.data.FromDate = $scope.TrailObj.FromDate;
                        o.data.ToDate = $scope.TrailObj.ToDate;

                        o.data.FromDateString = $scope.extractDate($scope.TrailObj.FromDate);
                        o.data.ToDateString = $scope.extractDate($scope.TrailObj.ToDate);

                        // o.data.DateMonth = $scope.TrailObj.FromDate.getMonth() + 1;
                        // o.data.DateDay = $scope.TrailObj.FromDate.getDate();
                        // o.data.DateYear = $scope.TrailObj.FromDate.getFullYear();

                        // o.data.DateMonth2 = $scope.TrailObj.ToDate.getMonth() + 1;
                        // o.data.DateDay2 = $scope.TrailObj.ToDate.getDate();
                        // o.data.DateYear2 = $scope.TrailObj.ToDate.getFullYear();

                        o.data.CostCenterIds = $scope.SelectedCostCenters;
                        MainService.GetTrialBalance(o.data).then(function (response) {
                            $scope.GlData = response.data.Data;
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) { },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                            },
                            AccountCode: {
                                type: "string",
                            },
                            TotalDebit: {
                                type: "number",

                            },
                            TotalCredit: {
                                type: "number",
                            },
                            Level: {
                                type: "number",
                            },
                            OpeningDebit: {
                                type: "number",
                            },
                            OpeningCredit: {
                                type: "number",
                            },

                            GrandDebit: {
                                type: "number",
                            },
                            GrandCredit: {
                                type: "number",
                            },
                            BalanceDebit: {
                                type: "number",
                            },
                            BalanceCredit: {
                                type: "number"
                            }
                        }
                    }
                },
                change: function (data) {
                    if (data.items.length > 0) {

                        data.sender._aggregateResult.OpeningCredit.sum = 0;
                        data.sender._aggregateResult.OpeningDebit.sum = 0;

                        data.sender._aggregateResult.TotalCredit.sum = 0;
                        data.sender._aggregateResult.TotalDebit.sum = 0;

                        data.sender._aggregateResult.BalanceDebit.sum = 0;
                        data.sender._aggregateResult.BalanceCredit.sum = 0;

                        angular.forEach(data.items, function (a) {
                            if (a.Level == 0) {
                                data.sender._aggregateResult.OpeningCredit.sum = data.sender._aggregateResult.OpeningCredit.sum + a.OpeningCredit;
                                data.sender._aggregateResult.OpeningDebit.sum = data.sender._aggregateResult.OpeningDebit.sum + a.OpeningDebit;

                                data.sender._aggregateResult.TotalCredit.sum = data.sender._aggregateResult.TotalCredit.sum + a.TotalCredit;
                                data.sender._aggregateResult.TotalDebit.sum = data.sender._aggregateResult.TotalDebit.sum + a.TotalDebit;

                                data.sender._aggregateResult.BalanceDebit.sum = data.sender._aggregateResult.BalanceDebit.sum + a.BalanceDebit;
                                data.sender._aggregateResult.BalanceCredit.sum = data.sender._aggregateResult.BalanceCredit.sum + a.BalanceCredit;
                            }
                        })
                    }
                },
                aggregate: [
                    {
                        field: "OpeningDebit",
                        aggregate: "sum"
                    },
                    {
                        field: "OpeningCredit",
                        aggregate: "sum"
                    },
                    {
                        field: "TotalDebit",
                        aggregate: "sum"
                    },
                    {
                        field: "TotalCredit",
                        aggregate: "sum"
                    },
                    {
                        field: "GrandDebit",
                        aggregate: "sum"
                    },
                    {
                        field: "GrandCredit",
                        aggregate: "sum"
                    },
                    {
                        field: "BalanceDebit",
                        aggregate: "sum"
                    },
                    {
                        field: "BalanceCredit",
                        aggregate: "sum"
                    }
                ],
                serverPaging: false,
                serverSorting: false,
                serverFiltering: false,
            });

            $scope.KendoGridOptions = {
                dataBound: function (e) {
                    var items = e.sender.items();
                    items.each(function (idx, item) {
                        var itemtemp = e.sender.dataItem(item);
                        if (itemtemp.Level == 3) {
                            $(item).addClass('error-text');
                            $(item).children().css("padding-left", "" + (item.Level * 10) + "px !important");
                        }
                    });
                },
                editable: false,
                toolbar: ["excel", "pdf"],
                pdf: {
                    fileName: "trailbalance.pdf",
                    allPages: true,
                    landscape: true,
                    paperSize: "A4",
                    margin: {
                        top: "3cm",
                        right: "1cm",
                        bottom: "1cm",
                        left: "1cm"
                    },
                    template: $("#page-template").html()
                },
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 100,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: {
                    virtual: true
                },
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "AccountCode",
                        title: "Account Code",
                        headerTemplate: $scope.LanguageData.accountcode,
                    },
                    {
                        field: "Name",
                        title: "Account Name",
                        // template: "<div style='padding-left:#=Level*10#px;'>#:Name#</div>",
                        template: function (dataItem) {
                            return (
                                "<a ng-dblclick='goGlDetails(dataItem)'><span style='color:" +
                                getColor(dataItem.Level) +
                                ";font-weight: " + getFontweight(dataItem.Level) + ";padding-left:" +
                                10 * dataItem.Level +
                                "px'>" +
                                kendo.htmlEncode(dataItem.Name) +
                                "</span></a>"
                            );
                        },
                        headerTemplate: $scope.LanguageData.accountname,
                    },

                    {
                        field: "OpeningDebit",
                        title: "Opening Debit",
                        template: "<div style='text-align: right'>#=kendo.toString(OpeningDebit, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n2')#",
                    },
                    {
                        field: "OpeningCredit",
                        title: "Opening Credit",
                        template: "<div style='text-align: right'>#=kendo.toString(OpeningCredit, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n2')#",
                    },
                    {
                        field: "TotalDebit",
                        title: "Total Debit",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalDebit, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n2')#",
                    },
                    {
                        field: "TotalCredit",
                        title: "Total Credit",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalCredit, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n2')#",
                    },
                    {
                        field: "BalanceDebit",
                        title: "Balance Debit",
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceDebit, 'n')#</div>",

                        footerTemplate: "#=kendo.toString(sum, 'n2')#",
                        headerTemplate: $scope.LanguageData.balancedebit,
                    },
                    {
                        field: "BalanceCredit",
                        title: "Balance Credit",
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceCredit, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n2')#",
                        headerTemplate: $scope.LanguageData.balancecredit,
                    }
                ],
            };

            $scope.GetReport = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            function getColor(level) {
                switch (level) {
                    case 0:
                        return "#12837c";
                    case 1:
                        return "black";
                    case 2:
                        return "blue";
                    case 3:
                        return "green";
                    case 4:
                        return "violet";
                    case 5:
                        return "orange";
                    case 6:
                        return "yellow";
                }
            }

            function getFontweight(level) {
                switch (level) {
                    case 0:
                        return 800;
                    case 1:
                        return 700;
                    case 2:
                        return 600;
                    case 3:
                        return 500;
                    case 4:
                        return 400;
                    case 5:
                        return 300;
                    case 6:
                        return 200;
                }
            }


            $scope.goGlDetails = function (data) {

                var FromDateString = $scope.extractDate($scope.TrailObj.FromDate);
                var ToDateString = $scope.extractDate($scope.TrailObj.ToDate);

                var url = $state.href("generalLedgerbyAcc",
                    {
                        accId: data.Id,
                        datefrom: FromDateString,
                        dateTo: ToDateString,
                    });
                $window.open(url, "_blank");
            }

            $scope.PrintLedger = function () {

                var Fromdate = $scope.extractDate($scope.TrailObj.FromDate);
                var ToDate = $scope.extractDate($scope.TrailObj.ToDate);

                var array = [];
                angular.forEach($scope.GlData, function (e) {
                    var temp = {
                        AccountId: e.Id,
                        AccountName: e.Name,
                        AccountCode: e.AccountCode != null ? e.AccountCode : "",
                        OpeningDebit: e.OpeningDebit,
                        OpeningCredit: e.OpeningCredit,
                        TotalDebit: e.TotalDebit,
                        TotalCredit: e.TotalCredit,
                        BalanceDebit: e.BalanceDebit,
                        BalanceCredit: e.BalanceCredit,
                        Level: e.Level,
                        DateFrom: Fromdate,
                        DateTo: ToDate,
                        Color: getColor(e.Level),
                    };
                    array.push(temp);
                });

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.PrintTempTrailBalncePrint(array).then(
                    function (response) {
                        if (response.data != null) {
                            $window.open(
                                config.basePath + "/Reports/" + response.data,
                                "_blank"
                            );
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    },
                    function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    }
                );
            }



        }]);






//            $scope.GetReport = function () {
//
//                $scope.AccLoad = true;
//
//                $scope.TrailObj.DateMonth = $scope.TrailObj.FromDate.getMonth() + 1;
//                $scope.TrailObj.DateDay = $scope.TrailObj.FromDate.getDate();
//                $scope.TrailObj.DateYear = $scope.TrailObj.FromDate.getFullYear();
//
//                $scope.TrailObj.DateMonth2 = $scope.TrailObj.ToDate.getMonth() + 1;
//                $scope.TrailObj.DateDay2 = $scope.TrailObj.ToDate.getDate();
//                $scope.TrailObj.DateYear2 = $scope.TrailObj.ToDate.getFullYear();
//
//                MainService.GetTrialBalance($scope.TrailObj).then(function (response) {
//
//                    $scope.AccLoad = false;
//
//                    OpeningDebitSum = 0;
//                    OpeningCreditSum = 0;
//                    DebitSum = 0;
//                    CreditSum = 0;
//                    TotalDebitSum = 0;
//                    TotalCreditSum = 0;
//                    BalanceDebitSum = 0;
//                    BalanceCreditSum = 0;
//
//                    angular.forEach(response.data, function (e) {
//                        if (e.Level == 0) {
//                            OpeningDebitSum += e.OpeningDebit;
//                            OpeningCreditSum += e.OpeningCredit;
//                            DebitSum += e.TotalDebit;
//                            CreditSum += e.TotalCredit;
//                            TotalDebitSum += e.GrandDebit;
//                            TotalCreditSum += e.GrandCredit;
//                            BalanceDebitSum += e.BalanceDebit;
//                            BalanceCreditSum += e.BalanceCredit;
//                        }
//                    });
//
//
//                    var grid = $("#trial-balance-grid").kendoGrid({
//                        dataBound: function (e) {
//                            var items = e.sender.items();
//                            items.each(function (idx, item) {
//                                var itemtemp = e.sender.dataItem(item);
//                                if (itemtemp.Level == 3) {
//                                    $(item).addClass('error-text');
//                                    $(item).children().css("padding-left", "" + (item.Level * 10) + "px !important");
//                                }
//                            });
//                        },
//                        pageable: "true",
//                        height: 600,
//                        resizable: true,
//                        toolbar: ["excel"],
//                        dataSource: {
//                            data: response.data,
//                            schema: {
//                                model: {
//                                    id: "Id",
//                                    fields: {
//                                        Name: {
//                                            type: "string",
//                                        },
//                                        AccountCode: {
//                                            type: "string",
//                                        },
//                                        TotalDebit: {
//                                            type: "number",
//
//                                        },
//                                        TotalCredit: {
//                                            type: "number",
//                                        },
//                                        Level: {
//                                            type: "number",
//                                        },
//                                        OpeningDebit: {
//                                            type: "number",
//                                        },
//                                        OpeningCredit: {
//                                            type: "number",
//                                        },
//
//                                        GrandDebit: {
//                                            type: "number",
//                                        },
//                                        GrandCredit: {
//                                            type: "number",
//                                        },
//                                        BalanceDebit: {
//                                            type: "number",
//                                        },
//                                        BalanceCredit: {
//                                            type: "number"
//                                        }
//
//                                    }
//                                }
//                            },
//                            change: function (data) {
//                                if (data.items.length > 0) {
//                                    data.sender._aggregateResult.BalanceDebit.sum = 0;
//                                    data.sender._aggregateResult.BalanceCredit.sum = 0;
//                                    angular.forEach(data.items, function (a) {
//                                        if (a.Level == 0) {
//                                            data.sender._aggregateResult.BalanceDebit.sum = data.sender._aggregateResult.BalanceDebit.sum + a.BalanceDebit;
//                                            data.sender._aggregateResult.BalanceCredit.sum = data.sender._aggregateResult.BalanceCredit.sum + a.BalanceCredit;
//                                        }
//                                    })
//                                }
//                            },
//
//                            aggregate: [
//                                {
//                                    field: "OpeningDebit",
//                                    aggregate: "sum"
//                                },
//                                {
//                                    field: "OpeningCredit",
//                                    aggregate: "sum"
//                                },
//                                {
//                                    field: "TotalDebit",
//                                    aggregate: "sum"
//                                },
//                                {
//                                    field: "TotalCredit",
//                                    aggregate: "sum"
//                                },
//                                {
//                                    field: "GrandDebit",
//                                    aggregate: "sum"
//                                },
//                                {
//                                    field: "GrandCredit",
//                                    aggregate: "sum"
//                                },
//                                {
//                                    field: "BalanceDebit",
//                                    aggregate: "sum"
//                                },
//                                {
//                                    field: "BalanceCredit",
//                                    aggregate: "sum"
//                                }
//                            ]
//                        },
//                        editable: false,
//                        pageable: false,
//                        filterable: false,
//                        sortable: true,
//                        groupable: false,
//                        pageable: {
//                            input: false,
//                            refresh: true,
//                            pageSizes: true,
//                            info: true,
//                        },
//                        columns: [
//                            {
//                                field: "AccountCode",
//                                title: "Account Code",
//                                headerTemplate: $scope.LanguageData.accountcode,
//                            },
//                            {
//                                field: "Name",
//                                title: "Account Name",
//                                template: "<div style='padding-left:#=Level*10#px;'>#:Name#</div>",
//                                headerTemplate: $scope.LanguageData.accountname,
//                            },
//
//                            {
//                                field: "OpeningDebit",
//                                title: "Opening Debit",
//                                template: "<div style='text-align: right'>#=kendo.toString(OpeningDebit, 'n')#</div>",
//
//                            },
//
//                            {
//                                field: "OpeningCredit",
//                                title: "Opening Credit",
//                                template: "<div style='text-align: right'>#=kendo.toString(OpeningCredit, 'n')#</div>",
//
//                            },
//                            {
//                                field: "TotalDebit",
//                                title: "Total Debit",
//                                template: "<div style='text-align: right'>#=kendo.toString(TotalDebit, 'n')#</div>",
//
//                            },
//
//                            {
//                                field: "TotalCredit",
//                                title: "Total Credit",
//                                template: "<div style='text-align: right'>#=kendo.toString(TotalCredit, 'n')#</div>",
//
//                            },
//                            {
//                                field: "BalanceDebit",
//                                title: "Balance Debit",
//                                template: "<div style='text-align: right'>#=kendo.toString(BalanceDebit, 'n')#</div>",
//
//                                footerTemplate: "#=kendo.toString(sum, 'n')#",
//                                headerTemplate: $scope.LanguageData.balancedebit,
//                            },
//
//                            {
//                                field: "BalanceCredit",
//                                title: "Balance Credit",
//                                template: "<div style='text-align: right'>#=kendo.toString(BalanceCredit, 'n')#</div>",
//                                footerTemplate: "#=kendo.toString(sum, 'n')#",
//                                headerTemplate: $scope.LanguageData.balancecredit,
//                            }
//
//                        ],
//                    });
//
//                }, function (err) {
//                    $scope.AccLoad = false;
//                    toastr.error("Error");
//                })
//
//
//
//            }
//            $scope.GetReport();





//                            {
//                                field: "OpeningDebit",
//                                title: "Opening Debit",
//                                footerTemplate: "#=kendo.toString(OpeningDebitSum, '0.00')#",
//                                headerTemplate: $scope.OpeningDebitLan,
//
//                            },
//                            {
//                                field: "OpeningCredit",
//                                title: "Opening Credit",
//                                footerTemplate: "#=kendo.toString(OpeningCreditSum, '0.00')#",
//                                headerTemplate: $scope.OpeningCreditLan,
//                            },
//
//                            {
//                                field: "TotalDebit",
//                                title: "Sub Debit Total",
//                                footerTemplate: "#=kendo.toString(DebitSum, '0.00')#",
//                                headerTemplate: $scope.SubDebitTotalLan,
//                            },
//                            {
//                                field: "TotalCredit",
//                                title: "Sub Credit Total",
//                                footerTemplate: "#=kendo.toString(CreditSum, '0.00')#",
//                                headerTemplate: $scope.SubCreditTotalLan,
//                            },
//                            {
//                                field: "GrandDebit",
//                                title: "Total Debit",
//                                footerTemplate: "#=kendo.toString(TotalDebitSum, '0.00')#",
//                                headerTemplate: $scope.TotalDebitLan,
//                            },
//                            {
//                                field: "GrandCredit",
//                                title: "Total Credit",
//                                footerTemplate: "#=kendo.toString(TotalCreditSum, '0.00')#",
//                                headerTemplate: $scope.TotalCreditLan,
//                            },
